import { Trash2, Download, FileDown } from 'lucide-react';
import { Button } from 'common/components';
import styles from './BulkActions.module.scss';

export interface BulkActionsHandlerParams {
    selectedCallId?: string;
}

export interface BulkActionsProps {
    selectedCalls: string[];
    handleDeleteCalls: (params: BulkActionsHandlerParams) => void;
    handleExportCSV: (params: BulkActionsHandlerParams) => void;
    totalRecords?: number;
    isAllPagesSelected?: boolean;
    onExportAll?: () => void;
    isExporting?: boolean;
}

export const BulkActions = ({
    selectedCalls,
    handleDeleteCalls,
    handleExportCSV,
    totalRecords,
    isAllPagesSelected,
    onExportAll,
    isExporting,
}: BulkActionsProps) => {
    const displayCount = isAllPagesSelected && totalRecords ? totalRecords : selectedCalls.length;

    return (
        <div className={styles.workflowLeadsActions}>
            <span>Selected {displayCount}</span>
            <div className={styles.buttonsContainer}>
                <Button
                    variant='primary'
                    size='sm'
                    icon={Trash2}
                    iconOnly
                    disabled={!selectedCalls.length}
                    onClick={() => handleDeleteCalls({})}
                />
                <Button
                    variant='primary'
                    size='sm'
                    icon={Download}
                    iconOnly
                    disabled={!selectedCalls.length || isExporting}
                    isLoading={isExporting}
                    onClick={() => handleExportCSV({})}
                />
                {onExportAll && (
                    <Button
                        variant='outline-primary'
                        size='sm'
                        icon={FileDown}
                        disabled={isExporting}
                        isLoading={isExporting}
                        onClick={onExportAll}
                    >
                        Export All{totalRecords ? ` (${totalRecords.toLocaleString()})` : ''}
                    </Button>
                )}
            </div>
        </div>
    );
};
